// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"CompanyUsersTable_deleteButton__2jTKm"};